import React from 'react';
import { Settings, Wrench, Sparkles } from 'lucide-react';
import Header from '../../../components/ui/Header';
import Sidebar from '../../../components/ui/Sidebar';

const SettingsPage = () => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <Sidebar />

      {/* Main Content */}
      <main className="ml-0 lg:ml-60 mt-[73px] p-8 min-h-screen">
        <div className="container mx-auto">
          {/* Page Header */}
          <div className="mb-8">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-gradient-to-br from-orange-500 to-orange-600 rounded-lg flex items-center justify-center">
                <Settings size={20} color="white" />
              </div>
              <div>
                <h1 className="text-2xl font-bold text-text-primary">Settings</h1>
                <p className="text-text-secondary text-sm">Manage your preferences and account settings</p>
              </div>
            </div>
          </div>

          {/* Coming Soon Card */}
          <div className="flex items-center justify-center min-h-[60vh]">
            <div className="relative">
              {/* Animated background glow */}
              <div className="absolute inset-0 bg-gradient-to-r from-orange-500/20 via-orange-600/20 to-green-500/20 rounded-3xl blur-3xl animate-pulse" />

              {/* Main card */}
              <div className="relative bg-surface border border-border rounded-2xl p-12 max-w-lg text-center">
                {/* Icon container with animation */}
                <div className="relative mb-8">
                  <div className="w-24 h-24 mx-auto bg-gradient-to-br from-orange-500/20 to-orange-600/20 rounded-full flex items-center justify-center">
                    <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-full flex items-center justify-center animate-bounce">
                      <Wrench size={32} color="white" />
                    </div>
                  </div>

                  {/* Sparkle decorations */}
                  <Sparkles
                    size={20}
                    className="absolute top-0 right-1/4 text-orange-400 animate-pulse"
                  />
                  <Sparkles
                    size={16}
                    className="absolute bottom-2 left-1/4 text-green-400 animate-pulse"
                    style={{ animationDelay: '0.5s' }}
                  />
                </div>

                {/* Text content */}
                <h2 className="text-3xl font-bold text-text-primary mb-3">
                  Coming Soon
                </h2>
                <p className="text-text-secondary mb-6 leading-relaxed">
                  We're crafting something amazing for you. Settings and preferences will be available here shortly.
                </p>

                {/* Feature preview pills */}
                <div className="flex flex-wrap justify-center gap-2 mb-8">
                  <span className="px-3 py-1 bg-orange-500/10 text-orange-400 rounded-full text-sm border border-orange-500/20">
                    Profile
                  </span>
                  <span className="px-3 py-1 bg-green-500/10 text-green-400 rounded-full text-sm border border-green-500/20">
                    Notifications
                  </span>
                  <span className="px-3 py-1 bg-orange-500/10 text-orange-400 rounded-full text-sm border border-orange-500/20">
                    Security
                  </span>
                  <span className="px-3 py-1 bg-green-500/10 text-green-400 rounded-full text-sm border border-green-500/20">
                    Preferences
                  </span>
                </div>

                {/* Progress indicator */}
                <div className="w-full bg-surface rounded-full h-2 overflow-hidden">
                  <div
                    className="h-full bg-gradient-to-r from-orange-500 to-green-500 rounded-full animate-pulse"
                    style={{ width: '65%' }}
                  />
                </div>
                <p className="text-xs text-text-secondary mt-2">Development in progress...</p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default SettingsPage;
